// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"5fd638e5","425":"5edf064e","510":"fc30db78","532":"414d80e7","633":"696c095f","634":"169c35fa","922":"aa7391c2","937":"27711b5e","972":"67edc389"}[chunkId] + ".chunk.js";
};